module.exports = __webpack_public_path__ + "img/big_11B03_yellow.d2292299.png";